module.exports = "/assets/328137674532c2b04503680a0c13871b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B2.png
// module id = 1215
// module chunks = 0